import React, { ReactNode } from "react";
import { useRoleAccess, UseRoleAccessConfig } from "@me-team/host/src/utils/useRoleAccess";

export interface WithRoleAccessProps extends UseRoleAccessConfig {
    fallback?: ReactNode;
    children: ReactNode;
}

const WithRoleAccess: React.FC<WithRoleAccessProps> = ({
    permission,
    anyPermissions,
    allPermissions,
    scope,
    fallback = null,
    children,
}) => {
    const hasAccess = useRoleAccess({
        permission,
        anyPermissions,
        allPermissions,
        scope,
    });

    return hasAccess ? <>{children}</> : <>{fallback}</>;
};

export default WithRoleAccess;
